import React from 'react';

const Button = ({ children, variant = 'default', className = '', ...props }) => {
  const variantClasses = {
    default: 'bg-azul-lago hover:bg-verde-bosque text-blanco-nieve',
    ghost: 'bg-transparent hover:bg-gris-pizarra text-azul-lago',
    outline: 'border border-azul-lago text-azul-lago bg-transparent hover:bg-azul-lago/10',
    secondary: 'bg-verde-esmeralda text-white hover:bg-verde-esmeralda/90',
  };

  const variantClass = variantClasses[variant] || variantClasses.default;

  return (
    <button className={`btn ${variantClass} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
};

export default Button;
